import type { User } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { type UseQueryOptions, useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'

type UserListParams = {
  isDeleted?: boolean
  isHidden?: boolean
}

type UseUsersListProps = {
  options?: Pick<UseQueryOptions<{ result: User[] }>, 'onSuccess'>
  params?: UserListParams
}

type UseUsersListReturn = {
  users: User[]
  isLoading: boolean
}

const USERS_URL = '/api/list/carers'

const useUsersList = ({
  options,
  params
}: UseUsersListProps): UseUsersListReturn => {
  const queryParams = getQueryParams(params || {})
  const { data, isLoading } = useQuery<{ result: User[] }>(
    ['users', params],
    () => getJSON({ url: `${USERS_URL}?${queryParams}` }),
    options
  )

  const users = data?.result

  return {
    users: users || [],
    isLoading
  }
}

export default useUsersList
